import { atom } from 'jotai'

export type MedicalRecordIdsUpdatedType = {
  id: string
  action: string
}

export const notiNewReversationsAtom = atom<number[]>([])

export const medicalRecordIdsUpdatedAtom = atom<MedicalRecordIdsUpdatedType[]>(
  [],
)

export const scheduleRangesAtom = atom<string>('')

export const hasChangeStatusAtom = atom<boolean>(false)
